var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 306,
    viewBox: "0 0 228 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 216.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 150.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 84.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 150.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 20.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 285.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 216.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 150.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 84.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 20.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 285.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 84.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 150.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 216.5,
    r: 20.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 71C44 71 55.2197 75.4041 63 75.55C71.1535 75.7029 83 71 83 71V97C83 97 71.3616 94.4 63.5 94.4C55.6384 94.4 44 97 44 97V71Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 137C44 137 55.2197 141.404 63 141.55C71.1535 141.703 83 137 83 137V163C83 163 71.3616 160.4 63.5 160.4C55.6384 160.4 44 163 44 163V137Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 203C44 203 55.2197 207.404 63 207.55C71.1535 207.703 83 203 83 203V229C83 229 71.3616 226.4 63.5 226.4C55.6384 226.4 44 229 44 229V203Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBgImage);
export default __webpack_public_path__ + "static/media/left_bg_image.99f7ad6b9ecc499f28cf6d651eeb473a.svg";
export { ForwardRef as ReactComponent };